// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2313":"04396cb3","3219":"fabb239a"}[chunkId] + ".chunk.css";
};